'use strict';

/**
 *
 * @name: registerTwitterFactory
 *
 */

function RegisterTwitterFactory($http, $rootScope, $sessionStorage) {

  'ngInject';

  function roar(whereFrom) {

    if (whereFrom === 'connections') {

      $sessionStorage.Nowness.twitter = whereFrom;
    }

    if (whereFrom === 'mergeFromConfirm') {

      $sessionStorage.Nowness.twitter = whereFrom;
    }

    if (whereFrom === 'loginButton') {

      $sessionStorage.Nowness.signUpFromLoginButton = 1;
    }

    $http
      .get($rootScope.apiUrlBak + '/twitter/auth-url')
      .success(function(data) {

        if (data.url) {

          window.location.href = data.url;
        }
      });
  }

  return {
    roar: roar
  };
}

export default RegisterTwitterFactory;



// WEBPACK FOOTER //
// ./app/components/nn-register/nn-register-twitter.factory.js